<template>
  <div class="filter-tags">
    <v-chip
      label
      color="black"
      v-for="technique in techniques"
      :key="technique.id"
      close
      @input="removeTechniqueTag(technique)"
    >{{ technique.name }}</v-chip>

    <template v-for="(tagFilters, i) in tags">
      <v-chip
        label
        color="black"
        v-for="(tag, j) in tagFilters"
        :key="i + '-' + j + '-' + tag.slug "
        close
        @input="removeTag(tag, tagFilters)"
      >{{ tag.name }}</v-chip>
    </template>

    <v-chip
      label
      color="black"
      v-if="priceRangeTag"
      close
      @input="clearPricesSelected()"
    >{{ priceRangeTag }}</v-chip>

    <template v-if="filters.colorSelected">
      <v-chip label color="black" close class="color-tag" @input="clearColor()">
        <span
          :class="['color-dot', 'color-dot-' + filters.colorSelected.color ]"
          :style="{backgroundColor: filters.colorSelected.color}"
        ></span>
        <span class="color-title">{{ filters.colorSelected.title }}</span>
      </v-chip>
    </template>

    <tk-btn
      v-if="hasTags"
      small
      flat
      class="text-none pa-0 reset-btn"
      @click="resetTags"
    >{{ $t('SEARCH.RESET_FILTERS') }}</tk-btn>
  </div>
</template>

<script>
export default {
  props: ["filters"],

  computed: {
    hasTags() {
      return (
        this.filters.sizesSelected.length ||
        this.filters.techniquesSelected.length ||
        this.filters.themesSelected.length ||
        this.filters.orientationsSelected.length ||
        this.filters.pricesSelected.price_min ||
        this.filters.colorSelected
      );
    },

    tags() {
      return [
        this.filters.themesSelected,
        this.filters.sizesSelected,
        this.filters.orientationsSelected
      ];
    },

    priceRangeTag() {
      // if (this.filters.pricesSelected.price_max === "8000+") return "8000+ €";
      if (
        this.filters.pricesSelected.price_min === null &&
        this.filters.pricesSelected.price_max === null
      ) {
        return null;
      } else if (
        this.filters.pricesSelected.price_min === null &&
        this.filters.pricesSelected.price_max != null
      ) {
        this.filters.pricesSelected.price_min = 0;
      }

      return `${this.filters.pricesSelected.price_min}-${this.filters.pricesSelected.price_max} €`;
    },

    techniques() {
      // Return only children
      return this.filters.techniquesSelected.filter(
        technique => !technique.children
      );
    }
  },

  methods: {
    removeTag(tag, collection) {
      const pos = collection.findIndex(item => item.id === tag.id);
      collection.splice(pos, 1);
    },

    removeTechniqueTag(technique) {
      // First remove all parents
      this.filters.techniquesSelected.forEach((item, index) => {
        if (item.children) {
          this.filters.techniquesSelected.splice(index, 1);
        }
      });
      const pos = this.filters.techniquesSelected.findIndex(
        item => item.id === technique.id
      );
      this.filters.techniquesSelected.splice(pos, 1);
      this.search();
    },

    /**
     * Temporary fix
     */
    resetTags() {
      this.filters.sizesSelected = [];
      this.filters.techniquesSelected = [];
      this.filters.themesSelected = [];
      this.filters.orientationsSelected = [];
      this.filters.pricesSelected.price_min = null;
      this.filters.pricesSelected.price_max = null;
      this.filters.colorSelected = null;
      // this.$router.replace({ name: "search" });
      this.search();
    },
    clearPricesSelected() {
      this.filters.pricesSelected.price_min = null;
      this.filters.pricesSelected.price_max = null;
      this.search();
    },
    clearColor() {
      this.filters.colorSelected = null;
      this.search();
    },
    search() {
      this.$emit("search");
    }
  }
};
</script>

<style lang="scss" scoped>
.color-chip {
  height: 30px;
  width: 30px;
  &.black {
    color: white !important;
  }
  &.grayscale {
    border-right: 16px solid black;
    border-left: 16px solid white;
  }
}

.reset-btn {
  text-decoration: underline;
  &:hover {
    text-decoration: none;
    background: none !important;
  }
}
</style>
